import { motion } from "framer-motion";
import { useContext } from "react";
import { ThemeContext } from "../../contexts/ThemeProvider";
import { LanguageContext } from "../../contexts/LanguageProvider";
import { PhoneGif } from "./PhoneGif";
import { getDeviceFromNavigator } from "../../utils/client-device";
type HeroProps = {
  onContactClick: () => void;
};
export default function Hero({ onContactClick }: HeroProps) {
  const bubbleVariant = {
    hover: { scale: 1.1, transition: { duration: 0.2 } },
    tap: { scale: 0.9, transition: { duration: 0.2 } },
  };

  const { colorsObj } = useContext(ThemeContext);
  const { t } = useContext(LanguageContext);

  const os = getDeviceFromNavigator();
  console.log(window);
  return (
    <div
      className={` p-8 min-h-screen shadow-lg relative flex items-center justify-center  px-8 md:px-24 lg:px-44 2xl:px-64`}
      style={{
        backgroundColor: "#000000",
        backgroundImage:
          `repeating-radial-gradient( circle at 0 0, transparent 0, ${colorsObj.colorBackground} 16px ), ` +
          ` repeating-linear-gradient(   ${colorsObj.colorOverlay}, ${colorsObj.colorOverlay} )`,
        opacity: 1,
      }}
    >
      <motion.div
        className={`flex items-center flex-col md:flex-row  justify-center mt-20 md:mt-0  gap-24`}
      >
        <motion.div
          className={`md:w-1/2 `}
          style={{
            color: colorsObj.colorText,
          }}
          initial={{ x: -50, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.7, ease: "easeOut" }}
        >
          <motion.h1
            className={` text-2xl md:text-4xl font-bold mb-8`}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2, duration: 0.6 }}
          >
            {t("home-hero-h1")}
          </motion.h1>
          <motion.p
            className="mb-12"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4, duration: 0.6 }}
          >
            {t("home-hero-p")}
          </motion.p>
          <div className="block md:hidden mb-8">
            <PhoneGif />
          </div>
          <motion.button
            onClick={onContactClick}
            className=" text-gray-950 px-6 py-2  w-full md:w-auto rounded-full font-semibold"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            style={{ backgroundColor: colorsObj.colorPrimary }}
            transition={{ delay: 0.6, duration: 0.5 }}
            whileHover={{
              scale: 1.05,
              boxShadow: "0 4px 20px rgba(0, 0, 0, 0.2)",
              transition: { duration: 0.2, delay: 0 },
            }}
            whileTap={{
              scale: 0.95,
              transition: { duration: 0.2 },
            }}
          >
            {t("home-hero-button")}
          </motion.button>
          {["ios", "android"].includes(os) && (
            <div className="mt-4 flex items-center gap-4 ">
              <motion.p
                initial={{ opacity: 0, y: 20, x: -20 }}
                animate={{ opacity: 1, y: 0, x: 0 }}
                transition={{ delay: 1, duration: 0.5 }}
                className="text-sm"
              >
                {t("home-hero-available")}
              </motion.p>
              {os === "ios" && (
                <motion.img
                  style={{ cursor: "pointer" }}
                  initial={{ opacity: 0, x: -20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: 1.2, duration: 0.5 }}
                  className="w-[32px] aspect-square"
                  src="/appstore.png"
                  onClick={() =>
                    (window.location.href =
                      "https://apps.apple.com/app/omnia360/id6746214465")
                  }
                />
              )}
              {os === "android" && (
                <motion.img
                  style={{ cursor: "pointer" }}
                  initial={{ opacity: 0, x: -20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: 1.2, duration: 0.5 }}
                  className="w-[32px] aspect-square"
                  src="/playstore.png"
                  onClick={() =>
                    (window.location.href =
                      "https://play.google.com/store/apps/details?id=dev.expo.erpmobile")
                  }
                />
              )}
            </div>
          )}
        </motion.div>

        <div className="hidden md:block">
          <PhoneGif />
        </div>
      </motion.div>
    </div>
  );
}
